module.exports = __webpack_public_path__ + "img/desktop.f5ea03b8.png";